import ReactDOM from "react-dom";

export default function ExplorerSelectPortal(props) {
  const portalRoot = document.getElementById("select-menu-portal");
  return ReactDOM.createPortal(props.children, portalRoot);
}
